<template>
    <v-card elevation="3">
        <v-card-text>
            <v-form ref="form">

                <div class="header-values">
                    <h3 class="value-title">VALOR TOTAL DE EMPENHO: {{ form.valor | currency }}</h3>
                    <h3 class="value-title">VALOR USADO NOS ITENS DE AQUISIÇÃO: {{ form.totalItensAquisicao | currency }}</h3>
                </div>
                <v-row>
                    <v-col cols="12" md="3">
                        <TextField :rules="[(v) => !!v || 'Campo obrigatório não informado.']" title="Nome:" id="nome"
                            :vModel="form.nome" @input="form.nome = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                    </v-col>

                    <v-col cols="12" md="3">
                        <TextField :rules="[(v) => !!v || 'Campo obrigatório não informado.']"
                            mask="####.##.######/####-##" title="Documento RBI:" id="documento_sei"
                            :vModel="form.documento_sei" @input="form.documento_sei = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                    </v-col>


                    <!-- <v-col cols="12" md="3">
                        <TextField :rules="[(v) => !!v || 'Campo obrigatório não informado.']" title="Elaborador:"
                            id="elaborador" :vModel="form.elaborador" @input="form.elaborador = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                    </v-col> -->

                    <!-- <v-col cols="12" md="3">
                        <TextField title="Valor" id="valor" :vModel="form.valor"
                            :rules="[valor => /^[0-9]+(\.[0-9]{1,2})?$/.test(valor) || 'Formato inválido']"
                            @input="form.valor = $event" :responsive="{
                            lg: 12,
                            md: 12,
                            sm: 12,
                            cols: 12,
                        }" />
                    </v-col> -->
                    <v-col cols="12" md="12">
                        <TextField :rules="[(v) => !!v || 'Campo obrigatório não informado.']" title="Descrição:"
                            id="descricao" :vModel="form.descricao" @input="form.descricao = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                    </v-col>

                    <!-- <v-col cols="12" class="py-0">
                        <label style="float:left;margin-top:10px;margin-bottom:-10px" for="firstField">
                            Validade:</label>
                    </v-col>
                    <v-col cols="12" md="3" class="custom-date-field">
                        <v-text-field id="firstField" ref="firstField" type="date" v-model="formattedDate"
                            :rules="[(v) => !!v || 'Campo obrigatório não informado.']" outlined />
                    </v-col> -->
                </v-row>

                <v-divider class="my-4"></v-divider>
                <div class="section-container">
                    <v-row>
                        <v-col cols="12">
                            <v-subheader class="section-title">
                                Dotação Orçamentária
                            </v-subheader>
                        </v-col>
                    </v-row>
                    <v-row v-for="(dotacao, dotacaoIndex) in form.dotacoes" :key="`dotacao-${dotacaoIndex}`"
                        class="align-center">
                        <v-col v-if="!dotacao.carregado" cols="12" md="2">
                            <AutocompleteField title="Exercício:" :id="`dotacao_exercicio_${dotacaoIndex}`"
                                :vModel="dotacao.exercicioSelected" :options="dotacao.exerciciosOptions"
                                @input="onExercicioSelected($event, dotacaoIndex)"
                                :responsive="{ lg: 12, md: 12, sm: 12, cols: 12 }" />
                        </v-col>

                        <v-col v-if="!dotacao.carregado" cols="12" md="2">
                            <AutocompleteField title="Unidade:" :id="`dotacao_unidade_${dotacaoIndex}`"
                                :vModel="dotacao.unidadeSelected" :options="dotacao.unidadesOptions"
                                @input="onUnidadeSelected($event, dotacaoIndex)"
                                :disabled="!dotacao.exercicioSelected || dotacao.unidadesOptions.length === 0"
                                :responsive="{ lg: 12, md: 12, sm: 12, cols: 12 }" />
                        </v-col>

                        <v-col v-if="!dotacao.carregado" cols="12" md="2">
                            <AutocompleteField :rules="[(v) => !!v || 'Campo obrigatório não informado.']"
                                title="Dotação Orçamentária:" :id="`dotacao_orcamentaria_${dotacaoIndex}`"
                                :vModel="dotacao.dotacao" :options="dotacao.dotacoesOptions"
                                @input="dotacao.dotacao = $event"
                                :disabled="!dotacao.unidadeSelected || dotacao.dotacoesOptions.length === 0"
                                :responsive="{ lg: 12, md: 12, sm: 12, cols: 12 }" />
                        </v-col>

                        <v-col v-if="dotacao.carregado" cols="12" md="3">
                            <AutocompleteField title="Dotação Orçamentária:" id="dotacao_orcamentaria"
                                :vModel="dotacao.dotacao" :options="dotacoesProp" @input="dotacao.dotacao = $event" :responsive="{
                                lg: 12,
                                md: 12,
                                sm: 12,
                                cols: 12,
                            }"/>
                        </v-col>

                        <v-col cols="12" md="2">
                            <TextField title="Valor Usado:" :id="`valor_usado_${dotacaoIndex}`"
                                :rules="[valor => /^[0-9]+(\.[0-9]{1,2})?$/.test(valor) || 'Formato inválido']"
                                :vModel="dotacao.valor" @input="dotacao.valor = $event" :disabled="!dotacao.dotacao"
                                :responsive="{ lg: 12, md: 12, sm: 12, cols: 12 }" />
                        </v-col>

                        <v-col v-if="form.dotacoes.length > 1" cols="12" md="2" class="text-center">
                            <v-btn color="red" icon @click="removeDotacao(dotacaoIndex)">
                                <v-icon>mdi-delete</v-icon>
                                Excluir
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="text-right">
                            <v-btn color="primary" class="add-button" @click="addDotacao">
                                <v-icon left>mdi-playlist-plus</v-icon>
                                + Adicionar Dotação
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="my-4"></v-divider>
                <div class="section-container">
                    <v-row>
                        <v-col cols="12">
                            <v-subheader class="section-title">
                                Itens de Aquisição
                            </v-subheader>
                        </v-col>
                    </v-row>
                    <v-row v-for="(item, itemIndex) in form.itensAquisicao" :key="`item-${itemIndex}`"
                        class="align-center">
                        <v-col cols="12" md="3">
                            <AutocompleteField :rules="[(v) => !!v || 'Campo obrigatório não informado.']"
                                title="Tipo de Item:" id="tipos_itens" :vModel="item.tipo_item" :options="itens"
                                @input="item.tipo_item = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField :rules="[
                        (v) =>
                            item.tipo_item !== 'ITENS_LICITACAO' ? !!v || 'Campo obrigatório não informado.' : true,
                    ]" title="Número RP:" id="numero_rp" :vModel="item.numero_rp" @input="item.numero_rp = $event"
                                :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField :rules="[
                        (v) =>
                            item.tipo_item !== 'ITENS_LICITACAO' ? !!v || 'Campo obrigatório não informado.' : true,
                    ]" title="Número Item RP:" id="numero_item_rp" :vModel="item.numero_item_rp"
                                @input="item.numero_item_rp = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField :rules="[
                        (v) =>
                            item.tipo_item !== 'ITENS_LICITACAO' ? !!v || 'Campo obrigatório não informado.' : true,
                    ]" title="Código do Item:" id="codigo_item" :vModel="item.codigo_item"
                                @input="item.codigo_item = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField :rules="[
                        (v) =>
                            !!v || 'Campo obrigatório não informado.',
                    ]" title="Descrição:" id="descricao_item" :vModel="item.descricao" @input="item.descricao = $event"
                                :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField title="Valor Unitário:" id="valor_unitario" :rules="[
                        (valor) =>
                            item.tipo_item !== 'ITENS_LICITACAO'
                                ? /^[0-9]+(\.[0-9]{1,2})?$/.test(valor) || 'Formato inválido'
                                : true,
                    ]" :vModel="item.valor_unitario" @input="item.valor_unitario = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" />
                        </v-col>

                        <v-col cols="12" md="2">
                            <TextField :rules="[
                        (v) =>
                            item.tipo_item !== 'ITENS_LICITACAO' ? !!v || 'Campo obrigatório não informado.' : true,
                    ]" title="Quantidade:" id="quantidade" :vModel="item.quantidade" @input="item.quantidade = $event"
                                :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" />
                        </v-col>

                        <v-col cols="12" md="3">
                            <TextField title="Valor Total:" id="valor_total"
                                :disabled="item.quantidade != '' && item.valor_unitario != ''" :rules="[
                        (valor) => !!valor || 'Campo obrigatório não informado.',
                        (valor) => /^[0-9]+(\.[0-9]{1,2})?$/.test(valor) || 'Formato inválido',
                    ]" :vModel="item.valor_total" @input="item.valor_total = $event" :responsive="{
                        lg: 12,
                        md: 12,
                        sm: 12,
                        cols: 12,
                    }" type="number" />
                        </v-col>

                        <v-col v-if="form.itensAquisicao.length > 1" cols="12" md="1" class="text-center">
                            <v-btn color="red" icon @click="removeItem(itemIndex)">
                                <v-icon>mdi-delete</v-icon>
                                excluir
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="text-right">
                            <v-btn color="primary" class="add-button" @click="addItem">
                                <v-icon left>mdi-playlist-plus</v-icon>
                                + Adicionar Item
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="my-4"></v-divider>

                <v-row class="footer-actions">
                    <v-col cols="12">
                        <v-row class="d-flex align-center justify-end">
                            <v-col cols="auto">
                                <v-btn class="clear-button" @click="limparFormulario">
                                    <v-icon left>mdi-refresh</v-icon>
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn color="primary" @click="salvarPlano">
                                    <v-icon left>mdi-content-save</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn color="primary" @click="consolidarPlano">
                                    <v-icon left>mdi-checkbox-marked-outline</v-icon>
                                    Salvar e Consolidar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>

        </v-card-text>
    </v-card>
</template>

<script>
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../components/fields/textField/TextField.vue";
import { DotacaoService } from "../../services/DotacaoService";
import { ExercicioService } from "../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../services/UnidadeExecutoraService"

export default {
    props: {
        form: Object,
        itens: Array,
        dotacoesProp: Array,
    },
    components: {
        TextField,
        AutocompleteField
    },
    computed: {
        formattedDate: {
            get() {
                return this.form.validade.split(' ')[0];
            },
            set(newDate) {
                this.form.validade = newDate + ' 00:00:00';
            }
        }
    },
    data: () => ({
        exercicioSelected: null,
        exerciciosOptions: [],
        unidadeSelected: null,
        unidadesOptions: [],
        dotacoes: [],
    }),
    watch: {
        'form.itensAquisicao': {
            handler(newItems) {
                let totalItens = 0;
                newItems.forEach((item) => {

                    if (item.valor_unitario && item.quantidade) {
                        item.valor_total = (parseFloat(item.valor_unitario) * parseFloat(item.quantidade)).toFixed(2);
                    } else {
                        item.valor_total = 0;
                    }

                    const valorTotalNumerico = parseFloat(item.valor_total);
                    totalItens += isNaN(valorTotalNumerico) ? 0 : valorTotalNumerico;
                });

                this.form.totalItensAquisicao = totalItens;
            },
            deep: true,
        },
        'form.dotacoes': {
            handler(newDotacoes, oldDotacoes) {
                const total = newDotacoes.reduce((total, dotacao) => {
                    const valorNumerico = parseFloat(dotacao.valor);
                    return total + (isNaN(valorNumerico) ? 0 : valorNumerico);
                }, 0);

                this.form.valor = total.toFixed(2);

                if (oldDotacoes && newDotacoes.length > oldDotacoes.length) {
                    const newIndex = newDotacoes.length - 1;
                    this.$nextTick(() => {
                        if (!newDotacoes[newIndex].exerciciosOptions || newDotacoes[newIndex].exerciciosOptions.length === 0) {
                            this.$set(newDotacoes[newIndex], 'exerciciosOptions', []);
                            this.listarExerciciosSelect(newIndex);
                        }
                    });
                }
            },
            deep: true,
        },
    },
    created() {
        this.calculateTotalItensAquisicao();
    },
    mounted() {
        this.carregarExerciciosParaTodasDotacoes();
    },
    methods: {
        carregarExerciciosParaTodasDotacoes() {
            if (!this.form || !this.form.dotacoes || this.form.dotacoes.length === 0) {
                return;
            }
            
            this.form.dotacoes.forEach((dotacao, index) => {
                if (!dotacao.exerciciosOptions) {
                    this.$set(dotacao, 'exerciciosOptions', []);
                }
                this.listarExerciciosSelect(index);
            });
        },
        async listarExerciciosSelect(dotacaoIndex) {
            try {
                if (!this.form || !this.form.dotacoes || !this.form.dotacoes[dotacaoIndex]) {
                    console.warn(`Dotação no índice ${dotacaoIndex} não existe`);
                    return;
                }

                const response = await ExercicioService.select();

                if (!response) {
                    console.error('Resposta vazia do serviço de exercícios');
                    this.$set(this.form.dotacoes[dotacaoIndex], 'exerciciosOptions', [
                        { text: "Selecione", value: "" }
                    ]);
                    return;
                }

                if (response.error) {
                    console.error('Erro na resposta:', response.message);
                    this.$set(this.form.dotacoes[dotacaoIndex], 'exerciciosOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Erro ao carregar exercícios", value: null, disabled: true }
                    ]);
                    return;
                }

                const exercicios = response.data;

                if (!exercicios || !Array.isArray(exercicios) || exercicios.length === 0) {
                    console.warn('Nenhum exercício encontrado. Response:', response);
                    this.$set(this.form.dotacoes[dotacaoIndex], 'exerciciosOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Nenhum exercício disponível", value: null, disabled: true }
                    ]);
                    return;
                }

                const exerciciosOptions = exercicios.map((el) => {
                    return {
                        text: String(el.ano),
                        value: el.ano,
                    };
                });

                exerciciosOptions.unshift({
                    text: "Selecione",
                    value: "",
                });

                this.$set(this.form.dotacoes[dotacaoIndex], 'exerciciosOptions', exerciciosOptions);
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
                if (this.form && this.form.dotacoes && this.form.dotacoes[dotacaoIndex]) {
                    this.$set(this.form.dotacoes[dotacaoIndex], 'exerciciosOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Erro ao carregar exercícios", value: null, disabled: true }
                    ]);
                }
            }
        },
        calculateTotalItensAquisicao() {
            let totalItens = 0;
            this.form.itensAquisicao.forEach((item) => {
                if (item.valor_unitario && item.quantidade) {
                    item.valor_total = (parseFloat(item.valor_unitario) * parseFloat(item.quantidade)).toFixed(2);
                } else {
                    item.valor_total = 0;
                }

                const valorTotalNumerico = parseFloat(item.valor_total);
                totalItens += isNaN(valorTotalNumerico) ? 0 : valorTotalNumerico;
            });

            this.totalItensAquisicao = totalItens;
            this.form.totalItensAquisicao = totalItens;
        },
        updateValorTotal(item) {
            if (item.valor_unitario && item.quantidade) {
                item.valor_total = (parseFloat(item.valor_unitario) * parseFloat(item.quantidade)).toFixed(2);
            } else {
                item.valor_total = 0;
            }
        },
        addDotacao() {
            this.$emit('addDotacao');
            this.$nextTick(() => {
                const newIndex = this.form.dotacoes.length - 1;
                this.$set(this.form.dotacoes[newIndex], 'exerciciosOptions', []);
                this.listarExerciciosSelect(newIndex);
            });
        },
        removeDotacao(index) {
            this.$emit('removeDotacao', index);
        },
        addItem() {
            this.$emit('addItem');
        },
        removeItem(index) {
            this.$emit('removeItem', index);
        },
        consolidarPlano() {
            const isValid = this.$refs.form.validate();

            if (!isValid) {
                return false;
            }

            this.$emit('consolidarPlano');
        },
        salvarPlano() {
            const isValid = this.$refs.form.validate();

            if (!isValid) {
                return false;
            }

            this.$emit('salvarPlano');
        },
        limparFormulario() {
            this.$emit('limparFormulario');
        },
        async onExercicioSelected(exercicio, dotacaoIndex) {
            this.form.dotacoes[dotacaoIndex].exercicioSelected = exercicio;
            this.form.dotacoes[dotacaoIndex].unidadeSelected = null;
            this.form.dotacoes[dotacaoIndex].unidadesOptions = [];
            this.form.dotacoes[dotacaoIndex].dotacao = null;
            this.form.dotacoes[dotacaoIndex].dotacoesOptions = [];

            if (!exercicio) {
                return;
            }

            try {
                const response = await UnidadeExecutoraService.selectWithExercicio(exercicio);

                if (!response) {
                    console.error('Resposta vazia do serviço de unidades');
                    this.$set(this.form.dotacoes[dotacaoIndex], 'unidadesOptions', [
                        { text: "Selecione", value: "" }
                    ]);
                    return;
                }

                if (response.error) {
                    console.error('Erro na resposta:', response.message);
                    this.$set(this.form.dotacoes[dotacaoIndex], 'unidadesOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Erro ao carregar unidades", value: null, disabled: true }
                    ]);
                    return;
                }

                const unidades = response.data;

                if (!unidades || !Array.isArray(unidades) || unidades.length === 0) {
                    console.warn('Nenhuma unidade encontrada para o exercício selecionado.');
                    this.$set(this.form.dotacoes[dotacaoIndex], 'unidadesOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Nenhuma unidade disponível", value: null, disabled: true }
                    ]);
                    return;
                }

                const unidadesOptions = unidades.map((el) => {
                    return {
                        text: `${el.codigo_unidade} - ${el.nome}`,
                        value: el.id,
                    };
                });

                unidadesOptions.unshift({
                    text: "Selecione",
                    value: "",
                });

                this.$set(this.form.dotacoes[dotacaoIndex], 'unidadesOptions', unidadesOptions);
            } catch (error) {
                console.error('Erro ao listar unidades:', error);
                this.$set(this.form.dotacoes[dotacaoIndex], 'unidadesOptions', [
                    { text: "Selecione", value: "" },
                    { text: "Erro ao carregar unidades", value: null, disabled: true }
                ]);
            }
        },
        async onUnidadeSelected(unidade, dotacaoIndex) {
            this.form.dotacoes[dotacaoIndex].unidadeSelected = unidade;
            this.form.dotacoes[dotacaoIndex].dotacao = null;
            this.form.dotacoes[dotacaoIndex].dotacoesOptions = [];

            try {
                const response = await DotacaoService.selectWithUnidade(unidade);

                if (!response) {
                    console.error('Resposta vazia do serviço');
                    this.$set(this.form.dotacoes[dotacaoIndex], 'dotacoesOptions', [
                        { text: "Selecione", value: "" }
                    ]);
                    return;
                }

                if (response.error) {
                    console.error('Erro na resposta:', response.message);
                    this.$set(this.form.dotacoes[dotacaoIndex], 'dotacoesOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Erro ao carregar dotações", value: null, disabled: true }
                    ]);
                    return;
                }

                const dotacoes = response.data;

                if (!dotacoes || !Array.isArray(dotacoes) || dotacoes.length === 0) {
                    console.warn('Nenhuma dotação encontrada para a unidade selecionada.');
                    this.$set(this.form.dotacoes[dotacaoIndex], 'dotacoesOptions', [
                        { text: "Selecione", value: "" },
                        { text: "Nenhuma dotação disponível", value: null, disabled: true }
                    ]);
                    return;
                }

                const dotacoesOptions = dotacoes.map((el) => {
                    const unidadeCodigo = el.unidade_executora?.codigo_unidade || 
                                         el.unidadeExecutora?.codigo_unidade || 
                                         'N/A';
                    const valor = el.valor ? 
                        parseFloat(el.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 
                        'R$ 0,00';
                    
                    return {
                        text: `Unidade: ${unidadeCodigo} - ${valor}`,
                        value: el.id,
                    };
                });

                dotacoesOptions.unshift({
                    text: "Selecione",
                    value: "",
                });

                this.$set(this.form.dotacoes[dotacaoIndex], 'dotacoesOptions', dotacoesOptions);

            } catch (error) {
                console.error('Erro ao listar dotações:', error);
                this.$set(this.form.dotacoes[dotacaoIndex], 'dotacoesOptions', [
                    { text: "Selecione", value: "" },
                    { text: "Erro ao carregar dotações", value: null, disabled: true }
                ]);
            }
        },
    }
};
</script>

<style scoped>
.custom-date-field .v-input__control {
    min-height: 48px;
}

.header-values {
    margin-bottom: 24px;
    padding: 16px;
    background-color: #F8FAFC;
    border-radius: 8px;
    border: 1px solid #E5E7EB;
}

.value-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
}

.section-container {
    background-color: #F8FAFC;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 16px;
    border: 1px solid #E5E7EB;
}

.section-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1F2937;
    padding: 0;
    margin-bottom: 16px;
}

.add-button {
    background-color: #16A34A !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    height: 40px !important;
}

.add-button:hover {
    background-color: #15803D !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3) !important;
}

.footer-actions {
    margin-top: 24px;
    margin-bottom: 16px;
}

.clear-button {
    background-color: #F3F4F6 !important;
    color: #374151 !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    height: 40px !important;
}

.clear-button:hover {
    background-color: #E5E7EB !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Estilos dos campos seguindo padrão do IndexRepasse.vue */
::v-deep .v-text-field,
::v-deep .v-autocomplete {
    margin: 0;
}

::v-deep .v-text-field .v-input__control,
::v-deep .v-autocomplete .v-input__control {
    min-height: 48px;
}

::v-deep .v-text-field .v-input__slot,
::v-deep .v-autocomplete .v-input__slot {
    border-radius: 8px;
    border: 1px solid #E5E7EB;
    background-color: #F9FAFB;
    transition: all 0.2s ease;
    min-height: 48px;
    padding: 0 16px;
}

::v-deep .v-text-field .v-input__slot:hover,
::v-deep .v-autocomplete .v-input__slot:hover {
    border-color: #16A34A;
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

::v-deep .v-text-field .v-input__slot:focus-within,
::v-deep .v-autocomplete .v-input__slot:focus-within {
    border-color: #16A34A;
    background-color: #FFFFFF;
    border-width: 2px;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
}

::v-deep label {
    font-size: 0.875rem;
    color: #374151;
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
}

::v-deep .v-text-field input,
::v-deep .v-autocomplete input {
    font-size: 1rem;
    color: #1F2937;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-autocomplete--outlined fieldset {
    border: none;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
::v-deep .v-autocomplete--outlined.v-input--is-focused fieldset {
    border: none;
}

::v-deep .v-input--is-disabled .v-input__slot {
    background-color: #F3F4F6 !important;
    border-color: #E5E7EB !important;
    opacity: 0.7;
}

::v-deep .v-input--is-disabled label {
    color: #9CA3AF !important;
}

::v-deep .v-input--is-disabled input {
    color: #6B7280 !important;
}

/* Botões de ação primários */
::v-deep .v-btn.primary {
    background-color: #16A34A !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    height: 40px !important;
}

::v-deep .v-btn.primary:hover {
    background-color: #15803D !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3) !important;
}

/* Botões de delete/remover */
::v-deep .v-btn[color="red"] {
    background-color: #EF4444 !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    text-transform: none !important;
}

::v-deep .v-btn[color="red"]:hover {
    background-color: #DC2626 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

/* Mensagens de erro */
::v-deep .v-messages__message {
    color: #DC2626;
    font-size: 0.75rem;
    margin-top: 4px;
}

/* Responsividade */
@media (max-width: 959px) {
    .section-container {
        padding: 16px;
    }
    
    .header-values {
        padding: 12px;
    }
}

@media (max-width: 599px) {
    .value-title {
        font-size: 0.8rem;
    }
    
    .section-title {
        font-size: 1rem;
    }
}
</style>